/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

//actions specific to action objects
export const ACTIONS_SET_TITLE = 'ACTIONS_SET_TITLE';
export const ACTIONS_SAVE = 'ACTIONS_SAVE';
export const ACTIONS_GET_START = 'ACTIONS_GET_START';

export const ACTIONS_ADD_EXAMPLE = 'ACTIONS_ADD_EXAMPLE';
export const ACTIONS_ADD_DISPLAY_NAME = 'ACTIONS_ADD_DISPLAY_NAME';
export const ACTIONS_ADD_MULTIPLE_EXAMPLES = 'ACTIONS_ADD_MULTIPLE_EXAMPLES';
export const ACTIONS_ADD_MULTIPLE_COUNTER_EXAMPLES =
  'ACTIONS_ADD_MULTIPLE_COUNTER_EXAMPLES';
export const ACTIONS_DELETE_EXAMPLE = 'ACTIONS_DELETE_EXAMPLE';
export const ACTIONS_UPDATE_EXAMPLE = 'ACTIONS_UPDATE_EXAMPLE';
export const ACTION_UPDATE_CONDITION = 'ACTION_UPDATE_CONDITION';
//actions specific to step objects
export const STEP_ADD_YES_NO_OPTIONS = 'STEP_ADD_YES_NO_OPTIONS';
export const STEP_DELETE = 'STEP_DELETE';
export const STEP_UPDATE_END_BEHAVIOR = 'STEP_UPDATE_END_BEHAVIOR';
export const STEP_SET_TEXT = 'STEP_SET_TEXT';
export const STEP_SET_TITLE = 'STEP_SET_TITLE';
export const STEP_CREATE = 'STEP_CREATE';
export const STEP_UPDATE_CONDITION = 'STEP_UPDATE_CONDITION';
export const STEP_REORDER = 'STEP_REORDER';
export const STEP_UPDATE_VALIDATION = 'STEP_UPDATE_VALIDATION';
export const STEP_DEFINE_CUSTOMER_RESPONSE = 'STEP_DEFINE_CUSTOMER_RESPONSE';
export const STEP_SET_FREE_TEXT_RESPONSE = 'STEP_SET_FREE_TEXT_RESPONSE';
export const STEP_REMOVE_CUSTOMER_RESPONSE = 'STEP_REMOVE_CUSTOMER_RESPONSE';
export const STEP_UPDATE_OPTIONS = 'STEP_UPDATE_OPTIONS';
export const STEP_UPDATE_REFERENCED_ENTITY = 'STEP_UPDATE_REFERENCED_ENTITY';
export const STEP_REMOVE_OPTIONS = 'STEP_REMOVE_OPTIONS';
export const STEP_UPDATE_CONTEXT = 'STEP_UPDATE_CONTEXT';
export const STEP_UPDATE_OUTPUT = 'STEP_UPDATE_OUTPUT';
export const STEP_UPDATE_RESPONSE_COLLECTION_BEHAVIOR =
  'STEP_UPDATE_RESPONSE_COLLECTION_BEHAVIOR';
export const STEP_ADD_DATEPICKER = 'STEP_ADD_DATEPICKER';
export const SET_DANGER_WORD_VALUES = 'SET_DANGER_WORD_VALUES';
export const SET_PROFANE_WORD_VALUES = 'SET_PROFANE_WORD_VALUES';
export const SET_STEP_MAX_HITS = 'SET_STEP_MAX_HITS';
